import { useParams } from 'react-router-dom';

import { AuditTrailTable } from '../../../components/audit-trail-table';
import { SettingsSectionHeading } from '@/new/components/settings-section';

export function MatterAuditTrail() {
  const { matterId } = useParams();
  if (!matterId) return null;

  return (
    <>
      <SettingsSectionHeading
        title="Matter Audit Trail"
        description="View the recorded actions and events in this Matter"
        inset={false}
        className="mb-7"
      />

      <AuditTrailTable className="px-0" matterId={matterId} grammar="this" />
    </>
  );
}
